import { CheckoutState } from '../../state';
import { getLastNameToPrefill } from '../../utils/user';
import { getBuyerLastNameFromSurveyData } from '../forms';

export const getLastNameToPrefillFirstAttendeeInfo = (state: CheckoutState) =>
    getBuyerLastNameFromSurveyData(state) || getLastNameToPrefill(state);
